@if (row().dropOffId || row().dropOff || row().dropOffExtended) {
  <div
    class="datatable-drop-off"
    [ngClass]="{ 'datatable-drop-off__radio-control': row().admins?.length }"
    [matTooltip]="tooltip()"
  >
    {{ row().dropOffId ?? row().dropOff?.idDevice ?? row()?.dropOffExtended?.id }}
  </div>
} @else if (!isEditing()) {
  <button mat-button (click)="onClickEdit()">
    <mat-icon color="warn">attachment</mat-icon>
    Attach drop Off
  </button>
} @else {
  <mat-form-field class="datatable-drop-off__field small-form-field" appearance="outline">
    <mat-label>Drop off devices</mat-label>
    <input type="text" matInput [formControl]="dropOffFormControl" [matAutocomplete]="auto" />
    <mat-icon matSuffix (click)="onClickClose()">close</mat-icon>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
      @for (option of filteredOptions(); track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}
